import { useDrag } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { ItemTypes } from "../../../abstract/controller/enum/dnd/ItemTypes";
import { StatusTypes } from "../../../abstract/controller/enum/dnd/StatusTypes";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import * as uuidUtils from "../../../abstract/controller/utils/uuidUtils";
import useStatus from "../../../abstract/hook/useStatus";
import {
  getIsHighlighted,
  getWindowLock
} from "../../../abstract/redux/slice/overlaySlice";
import { setDrag, setIdle } from "../../../abstract/redux/slice/statusSlice";
import styles from "./ConditionMain.module.scss";

function ConditionMain({ node, children }) {
  const _dispatch = useDispatch();

  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _m_uuid = uuidUtils.getMainUuid(_uuid);

  const _status = useStatus(_id);
  const _isLocked = useSelector(getWindowLock);
  const _isHighlighted = useSelector(getIsHighlighted(_id));

  const _name = nodeUtils.getName(node);

  const _isDragged = _status === StatusTypes.DRAGGED;

  //---------------------------------------------------------------------

  const [, drag] = useDrag(
    () => ({
      type: ItemTypes.CONDITION,
      item: { element: node },
    }),
    [node]
  );

  //---------------------------------------------------------------------

  const getClassStyle = () => {
    if (_isDragged) {
      return styles["style--dragged"];
    }

    return _name ? styles["style--default"] : styles["style--ephemeral"];
  };

  const getClassBackground = () => {
    if (_isHighlighted) {
      return styles["style--highlight"];
    }

    return _isLocked || _isDragged  || !_name ? "" : styles["style--hover"];
  };

  const getClassNesting = () => {
    return styles[`style--background`];
  };

  const getClass = () => {
    return `${getClassNesting()} ${getClassStyle()} ${getClassBackground()}`;
  };

  //---------------------------------------------------------------------

  const handleOnDragStart = () => {
    const _element = document.querySelector(`#${_m_uuid}`);
    const _size = _element.getBoundingClientRect();
    _dispatch(setDrag({ id: _id, size: { width: _size.width, height: _size.height } }));
  };

  const handleOnDragEnd = () => {
    _dispatch(setIdle());
  };

  const canDrag = () => {
    return _name;
  };

  return (
    <div
      id={_m_uuid}
      ref={canDrag() ? drag : null}
      className={getClass()}
      onDragStart={handleOnDragStart}
      onDragEnd={handleOnDragEnd}
      >
      {children}
    </div>
  );
}

export default ConditionMain;
